import React from 'react'
import { Dialog, DialogContent, DialogContentText, LinearProgress } from '@mui/material'
import { connect } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import useStyles from './styles'

function LoadingPage(props) {
    const classes = useStyles()

    return (
        <Dialog
            fullWidth
            maxWidth={"xs"}
            open={props.loadingPage} >
            <DialogContent>
                <DialogContentText className={classes.dialogContentText}>
                    <IntlMessages id="pleaseWait" />
                </DialogContentText>
                <LinearProgress color="primary" className={classes.linearProgress} />
            </DialogContent>
        </Dialog>
    )
}

const mapStateToProps = (state) => {
    return {
        loadingPage: state.common.loadingPage
    }
}

export default connect(mapStateToProps)(LoadingPage)

